export enum Role {
  EXPLORER = 'explorer',
  SUPPORTER = 'supporter',
  AMBASSADOR = 'ambassador',
  FOUNDER = 'founder',
}
